// extracted by mini-css-extract-plugin
module.exports = {"hearingAidContainer":"HearingAidSearch_hearingAidContainer__15YsW","verbage":"HearingAidSearch_verbage__2sire","hearingAidImage":"HearingAidSearch_hearingAidImage__IyB50"};